import { render, staticRenderFns } from "./ConfirmRessetPassword.vue?vue&type=template&id=2af5b999&scoped=true&"
import script from "./ConfirmRessetPassword.vue?vue&type=script&lang=js&"
export * from "./ConfirmRessetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRessetPassword.vue?vue&type=style&index=0&id=2af5b999&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af5b999",
  null
  
)

export default component.exports